import { Download, ChevronDown } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const SCHEMA_FIELDS = [
  { field: "provider_ticket_id", type: "string", required: true, values: "Unique ticket ID from source system" },
  { field: "subject", type: "string", required: true, values: "Ticket title" },
  { field: "description", type: "string", required: false, values: "Ticket body" },
  { field: "priority", type: "string", required: false, values: "low, medium, high, urgent" },
  { field: "ticket_type", type: "string", required: false, values: "incident, request, task" },
  { field: "requester_email", type: "string", required: false, values: "Email of ticket requester" },
  { field: "ticket_created_at", type: "string", required: false, values: "ISO 8601 datetime" },
  { field: "status", type: "string", required: false, values: "open, in_progress, pending, resolved, closed" },
  { field: "conversations", type: "array", required: false, values: "Array of comment objects" },
  { field: "conversations[].body", type: "string", required: true, values: "Comment text" },
  { field: "conversations[].author_email", type: "string", required: false, values: "Comment author email" },
  { field: "conversations[].created_at", type: "string", required: false, values: "ISO 8601 datetime" },
];

export function HarmonyFormatInfo() {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-md border bg-muted/30 p-3 space-y-2">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Upload a JSONL file with one ticket per line in Harmony's normalized format.
        </p>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="shrink-0"
          onClick={() => {
            const a = document.createElement("a");
            a.href = "/templates/harmony-import-sample.jsonl";
            a.download = "harmony-import-sample.jsonl";
            a.click();
          }}
        >
          <Download className="mr-1.5 h-3 w-3" />
          Sample file
        </Button>
      </div>

      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="flex items-center gap-1 px-0 text-xs text-muted-foreground hover:text-foreground"
          >
            Schema reference
            <ChevronDown
              className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`}
            />
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="pt-2">
          <div className="rounded-md border overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="text-xs">Field</TableHead>
                  <TableHead className="text-xs">Type</TableHead>
                  <TableHead className="text-xs">Required</TableHead>
                  <TableHead className="text-xs">Values</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {SCHEMA_FIELDS.map((f) => (
                  <TableRow key={f.field}>
                    <TableCell className="font-mono text-xs">{f.field}</TableCell>
                    <TableCell className="text-xs">{f.type}</TableCell>
                    <TableCell className="text-xs">{f.required ? "Yes" : "No"}</TableCell>
                    <TableCell className="text-xs text-muted-foreground">{f.values}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}
